import { useSearchParams } from "react-router-dom";
import PublicMenuPage from "@/pages/PublicMenuPage";
import ShopPage from "@/pages/ShopPage";

export default function PublicMenuEntry() {
  const [params] = useSearchParams();
  return params.get("modo") === "delivery" && !params.get("pedido") ? <ShopPage /> : <PublicMenuPage />;
}
